export default __webpack_public_path__ + "static/media/learose5.15e0b3b3.jpg";